import { AppText } from 'components/atoms';
import { useMemo } from 'react';

type JournalSchoolYearsDisplayProps = {
    schoolYears: string[];
    fromYearFilter?: number;
    toYearFilter?: number;
};

const SCHOOL_YEAR_SEPARATOR = '/';

export const SchoolYearsDisplay = ({
    schoolYears,
    fromYearFilter,
    toYearFilter,
}: JournalSchoolYearsDisplayProps) => {
    const schoolYearsText = useMemo(() => {
        if (fromYearFilter && toYearFilter) {
            if (fromYearFilter === toYearFilter) {
                return schoolYears.join(', ');
            }
            return schoolYears
                .filter((schoolYear) => {
                    const [startYear, finishYear] = schoolYear.split(SCHOOL_YEAR_SEPARATOR);
                    return (
                        fromYearFilter <= Number(startYear) && toYearFilter >= Number(finishYear)
                    );
                })
                .join(', ');
        }
        return schoolYears.join(', ');
    }, [fromYearFilter, schoolYears, toYearFilter]);

    return (
        <AppText textType="BodyMediumSemiBold" margin={0}>
            {schoolYearsText}
        </AppText>
    );
};
